module.exports = __webpack_public_path__ + "img/Report.935879c4.jpg";